import { FilestackImageFit } from 'api/types/shared.types';
import { imageUrl } from 'utils/filestack';

import { identityFilter } from './functional';

type Props = {
  handle: string;
  width?: number;
  height?: number;
  fit?: FilestackImageFit;
  format?: string;
  mimetype?: string;
  quality?: number;
};

export function getImageSrc({
  handle,
  width,
  height,
  fit,
  format,
  mimetype,
  quality,
}: Props) {
  const resize = [
    width && `w:${Math.round(width)}`,
    height && `h:${Math.round(height)}`,
  ]
    .filter(identityFilter)
    .join(',');

  const resizeQuery = resize && `resize=${resize}${fit ? `,fit:${fit}` : ''}`;
  const qualityQuery = `quality=value:${quality || 70}`;
  const formatQuery = format && `output=format:${format}`;

  const transform = [resizeQuery, qualityQuery, formatQuery]
    .filter(Boolean)
    .join('/');

  return imageUrl({ handle, mimetype, transform });
}
